// Canonical dispatch vehicle taxonomy (2026-07-28). The DB function
// vehicle_can_serve() is the canonical grid — this module mirrors the
// UI-relevant rules so Verifications and Providers cannot drift.
export const DISPATCH_VEHICLES = ["motorcycle", "tricycle", "car", "van", "truck"];

// Hauling-capable heavy cargo vehicles; never carry passengers.
export const HEAVY_VEHICLES = ["van", "truck"];

export const canServeRides = v =>
  !!v && DISPATCH_VEHICLES.includes(v) && !HEAVY_VEHICLES.includes(v);

// driver_profiles declared (self-reported) taxonomy -> suggested canonical
// dispatch type; admin confirms against the photos. Van has no declared
// source — admins pick it manually.
export const DECLARED_TO_DISPATCH = {
  kehkeh: "tricycle",
  motorbike: "motorcycle",
  sedan: "car",
  suv: "car",
  pickup: "truck",
  box_truck: "truck",
  trailer: "truck",
  dump_truck: "truck",
  tow_truck: "truck",
};
